import PropTypes from 'prop-types';
import React, { Component } from "react";
import Loader from "react-loader-spinner";
import { connect } from "react-redux";
import Modal from "reboron/DropModal";
import * as networkAction from "../../actions/networkActions";
import * as userAction from "../../actions/userAction";
import LoadingTable from "../../components/LoadingTable";
import { PageHeader } from "../../components/PageHeader";
import UserPasswordView from "../../components/UserPasswordView";
import UserView from "../../components/UserView";
import { Activity, checkUserActivity } from "../../helpers/userActivity";
import { arrayIdsToName, formatDateTime } from "../../helpers/utils";

/**
 * Komponent zawierający kolekcję dostępnych użytkowników.
 */
class Users extends Component {

  constructor(props) {
    super(props);

    this.state = {
      // zawartosc modala (dodaj, edytuj, usun)
      modalContent: null,
      // czy dane do tabelki sie zaladowaly
      loading: true,
      // kolumy do tabelki
      tableColumns: this.getTableColumns()
    };
  }

  componentDidMount() {

    this._isMounted = true;

    //ladowanie danych do tabelki
    this.props.onFetch(() => {
      //po pobraniu danych do tabelki zmieniamy stan na zaladowany jesli jeszcze komponent jest aktywny
      if (this._isMounted) {
        this.setState({ loading: false });
      }
    });

    //ladowanie danych zaleznych do tabelki
    this.props.onDependentFetch();

  }

  componentDidUpdate(prevProps, prevState) {

    //aktualizujemy tylko wtedy kiedy zmienil sie stan rol lub sieci
    if (prevProps.roleList.length !== this.props.roleList.length || prevProps.networkList.length !== this.props.networkList.length) {
      this.setState({ tableColumns: this.getTableColumns() });
    }

  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  /**
   * Tworzenie kolumn do tabelki
   */
  getTableColumns = () => {
    return [
      {
        Header: this.props.formatMessage("user.id"),
        accessor: "id",
        headerStyle: { whiteSpace: "unset" },
        style: { whiteSpace: "unset", textAlign: "right" }
      },
      {
        Header: this.props.formatMessage("user.firstName"),
        accessor: "firstName",
        headerStyle: { whiteSpace: "unset" },
        style: { whiteSpace: "unset" }
      },
      {
        Header: this.props.formatMessage("user.lastName"),
        accessor: "lastName",
        headerStyle: { whiteSpace: "unset" },
        style: { whiteSpace: "unset" }
      },
      {
        Header: this.props.formatMessage("user.email"),
        accessor: "email",
        headerStyle: { whiteSpace: "unset" },
        style: { whiteSpace: "unset" }
      },
      {
        Header: this.props.formatMessage("user.roles"),
        id: "roleIds",
        headerStyle: { whiteSpace: "unset" },
        style: { whiteSpace: "unset" },
        accessor: (data) => arrayIdsToName(data.roleIds, this.props.roleList),
        Cell: row => {
          if (this.props.roleList.length === 0) {
            return <Loader type="Watch" color="#1797be" height={18} width={18} />;
          }
          return <div>{row.value}</div>;
        }
      },
      {
        Header: this.props.formatMessage("user.networks"),
        id: "networkIds",
        headerStyle: { whiteSpace: "unset" },
        style: { whiteSpace: "unset" },
        accessor: (data) => arrayIdsToName(data.networkIds, this.props.networkList),
        Cell: row => {
          if (this.props.networkList.length === 0) {
            return <Loader type="Watch" color="#1797be" height={18} width={18} />;
          }
          return <div>{row.value}</div>;
        }
      },
      {
        Header: this.props.formatMessage("user.registrationDate"),
        id: "registrationDate",
        headerStyle: { whiteSpace: "unset" },
        style: { whiteSpace: "unset" },
        maxWidth: 180,
        accessor: data => {
          return formatDateTime(data.registrationDate);
        }
      },
      {
        Header: this.props.formatMessage("user.modificationDate"),
        id: "modificationDate",
        //accessor: 'modificationDate',
        headerStyle: { whiteSpace: "unset" },
        style: { whiteSpace: "unset" },
        maxWidth: 180,
        accessor: data => {
          return formatDateTime(data.modificationDate);
        }
      },
      {
        Header: "",
        Cell: row => (
          <div>
            <button
              className="w3-button w3-text-theme w3-hover-none w3-hover-text-theme-dark"
              onClick={() => this.onRowEditClick(row.original)}
            >
              <i className="far fa-edit" />
            </button>
            <button
              className="w3-button w3-text-theme w3-hover-none w3-hover-text-theme-dark"
              onClick={() => this.onRowEditPasswdClick(row.original)}
            >
              <i className="fa fa-key" />
            </button>
            <button
              className="w3-button w3-text-theme w3-hover-none w3-hover-text-theme-dark"
              onClick={() => this.onRowDeleteClick(row.original)}
            >
              <i className="fas fa-trash-alt" />
            </button>
          </div>
        )
      }
    ];
  }

  /**
   * Pokazuje modal
   */
  showModal() {
    this.refs.modal.show();
  }

  /**
   * Chowa modal
   */
  hideModal = () => {
    if (this.state.modalContent !== null) {
      this.setState({ modalContent: null });
      this.refs.modal.hide();
    }
  };

  /**
   * Akcja na klik przycisku dodania
   */
  onAddButtonClick = () => {
    //domyslmy model uzykownika
    let defaultUser = {
      firstName: "",
      lastName: "",
      email: "",
      networkIds: [],
      roleIds: []
    };
    this.setState({
      modalContent: (
        <UserView
          title={this.props.formatMessage("app.userPage.addUser")}
          user={defaultUser}
          roleList={this.props.roleList}
          networkList={this.props.networkList}
          cancelText={this.props.formatMessage("app.action.cancel")}
          sumbitText={this.props.formatMessage("app.action.submit")}
          onCancel={this.hideModal}
          onSubmit={this.onCreateAction}
        />
      )
    });

    this.showModal();
  };

  /**
   * Akcja na klik edycji wiersza w tabelce
   */
  onRowEditClick = data => {
    this.setState({
      modalContent: (
        <UserView
          title={this.props.formatMessage("app.userPage.editUser")}
          user={data}
          roleList={this.props.roleList}
          networkList={this.props.networkList}
          cancelText={this.props.formatMessage("app.action.cancel")}
          sumbitText={this.props.formatMessage("app.action.submit")}
          onCancel={this.hideModal}
          onSubmit={this.onUpdateAction}
        />
      )
    });

    this.showModal();
  };

  /**
   * Akcja na klik edycji wiersza w tabelce -hasło
   */
  onRowEditPasswdClick = data => {
    this.setState({
      modalContent: (
        <UserPasswordView
          title={this.props.formatMessage("app.userPage.editUserPassword")}
          userId={data.id}
          cancelText={this.props.formatMessage("app.action.cancel")}
          sumbitText={this.props.formatMessage("app.action.submit")}
          onCancel={this.hideModal}
          onSubmit={this.onUpdatePasswordAction}
        />
      )
    });

    this.showModal();
  };

  /**
   * Akcja na klik kasowania wiersza w tabelce
   */
  onRowDeleteClick = data => {
    this.setState({
      modalContent: (
        <UserView
          title={this.props.formatMessage("app.userPage.deleteUser")}
          user={data}
          roleList={this.props.roleList}
          networkList={this.props.networkList}
          cancelText={this.props.formatMessage("app.action.cancel")}
          sumbitText={this.props.formatMessage("app.action.delete")}
          onCancel={this.hideModal}
          onSubmit={() => this.onDeleteAction(data)}
        />
      )
    });

    this.showModal();
  };

  /**
   * Akcja po zatwierdzeniu tworzenia
   */
  onCreateAction = data => {
    this.props.onCreate(data);
    this.hideModal();
  };

  /**
   * Akcja po zatwierdzeniu aktualizacji
   */
  onUpdateAction = data => {
    this.props.onUpdate(data);
    this.hideModal();
  };

  /**
   * Akcja po zatwierdzeniu aktualizacji hasła
   */
  onUpdatePasswordAction = data => {
    this.props.onUpdatePassword(data);
    this.hideModal();
  };

  /**
   * Akcja po zatwierdzeniu kasowania
   */
  onDeleteAction = data => {
    this.props.onDelete(data);
    this.hideModal();
  };

  addButton() {
    return <button
      className="w3-btn w3-theme-dark"
      onClick={() => this.onAddButtonClick()}
    >
      {this.props.formatMessage("app.userPage.addUser")}
    </button>
  }

  render() {

    return (
      <div>
        <PageHeader text="app.userPage.title" />

        {checkUserActivity(this.props.authenticatedUser, Activity.ADD_USER) && this.addButton()}

        <Modal ref={"modal"}>
          {this.state.modalContent}
        </Modal>

        <LoadingTable
          data={this.props.userList}
          columns={this.state.tableColumns}
          loading={this.state.loading}

        />
      </div>
    );
  }
}

Users.propTypes = {
  formatMessage: PropTypes.func.isRequired
};

const mapStateToProps = state => {
  return {
    userList: state.userReducer.userList,
    roleList: state.userReducer.roleList,
    networkList: state.networkReducer.networkList,
    authenticatedUser: state.authReducer.authenticatedUser
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onFetch: callback => {
      dispatch(userAction.fetchUsers(callback));
    },
    onDependentFetch: callback => {
      dispatch(userAction.fetchUserRoles());
      dispatch(networkAction.fetchNetworks());
    },
    onDelete: user => {
      dispatch(userAction.deleteUser(user.id));
    },
    onCreate: user => {
      dispatch(userAction.createUser(user));
    },
    onUpdate: user => {
      dispatch(userAction.updateUser(user));
    },
    onUpdatePassword: userPassword => {
      dispatch(userAction.updateUserPassword(userPassword));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Users);
